import { Form, Input } from 'antd'
import { isEmpty } from 'lodash'
import { stopEvent } from 'helpers/events'
import { t } from 'helpers/i18n'
import { showValidationError } from 'helpers/errors'
import Modal from 'elements/Modal'

function FormView(props) {
  const { form, visible, onCancel, onSubmit } = props

  function handleSubmit(e) {
    stopEvent(e)

    form.validateFields((errors, values) => {
      if (isEmpty(errors)) {
        onSubmit(values)
      } else {
        showValidationError()
      }
    })
  }

  return (
    <Modal
      title={t('addPackingListNumber')}
      okText={t('add')}
      onOk={handleSubmit}
      onCancel={onCancel}
      visible={visible}
    >
      <Form layout="vertical" onSubmit={handleSubmit} colon={false}>
        <Form.Item label={t('packingListNumber')}>
          {form.getFieldDecorator('packingListNumber', {
            rules: [{ required: true, message: t('requiredField') }],
          })(<Input autoFocus />)}
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default Form.create()(FormView)
